import groupItems from '../utils/groupItems';
import getItemsFromCSV from '../utils/getItemsFromCSV';

export default async () => {
    const norwegianSurnamesData = await getItemsFromCSV('/csv/norwegianSurnamesAndMnemonics.csv');

    return groupItems(norwegianSurnamesData);
};
